import store from "@/store/index";
import {Loading, MessageBox} from "element-ui";
import axios from "@/axios/axios"
import api from "@/axios/index"

//url把 key转换成URL
function getUrl(key) {
    return store.state.bases.urlMap.get(key)
}

function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}

function getGuid() {
    return (S4() + S4() +'-' +S4() +'-' +S4() +'-' +S4() +'-' +S4() +S4() +S4());
}

//简单的节流函数
function throttle(fn, delay) {
    let timer;
    return function () {
        let _this = this;
        let args = arguments;
        if (timer) {
            return;
        }
        timer = setTimeout(function () {
            fn.apply(_this, args);
            timer = null;
        }, delay)
    }
}


//获取code
function getCode() {
    let  num="";
    for(let i=0;i<6;i++)
    {
        num += Math.floor(Math.random()*10);
    }
    return num;
}

//获取URL参数
function getUrlVal(variable) {
    // return '0510D02D-3A1F-4796-B303-DAAE36394606';
    let query = window.location.search.substring(1);
    let vars = query.split("&");
    for (let i=0;i<vars.length;i++) {
        let pair = vars[i].split("=");
        console.log('pair[1]')
        console.log(pair[1])
        if(pair[0] == variable){return pair[1];}
    }
    return(false);
}

//获取URL参数然后请求地址
let val = ''
function GetInterfaceAddress() {
    let loadingInstance = Loading.service({
        background: 'rgba(0, 0, 0, 0.7)',
        text: '加载中...'
    });
    // if (getUrlVal('companyid'))
    //val = getUrlVal('companyid')
    val = '0510D02D-3A1F-4796-B303-DAAE36394606'
    axios.post('https://wsbusiness.visumall.com/BusinessConfig.ashx?cmd=GetInterfaceAddress', {
        "token": {
            "sToken": "8BED23DE028E0E9966B8CE9E8F77DB89",
            "TimeSpan": "1535942069232"
        },
        "SearchCondition":{
            "BCTypeId": val
        }
    })
        .then(res => {
            if (res.InterfaceAddress) {
                getAllUrl(res.InterfaceAddress, loadingInstance)
            }
        })
}

//获取所有的URL的KEY
function getAllUrl (url, loadingInstance) {
    axios.post(url,
        {
            "token": {
                "sToken": "8BED23DE028E0E9966B8CE9E8F77DB89",
                "TimeSpan": "1535942069232"
            },
            "Version": "4",
            "Type":"VisumallIOSAPP"
        }
    )
        .then(res => {
            if (res && res.GetListResult.length > 0) {
                store.commit('bases/UpUrlArr', res.GetListResult)
                let item = new Map()
                for (let i = 0; i < res.GetListResult.length; i++) {
                    item.set(res.GetListResult[i].IAKey, res.GetListResult[i].IAValue)
                }
                store.commit('bases/UpUrlMap', item)
                loadingInstance.close();
                console.log('getAllUrl')
                getAreaGetListLevel();
            }else {
                MessageBox('数据加载失败，请稍后再试！', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning',
                    center: true})
            }
        })
        .catch(err => {
            MessageBox('数据加载失败，请稍后再试！', '提示', {
                confirmButtonText: '确定',
                type: 'warning',
                center: true})
            loadingInstance.close();
        })
}

function getAreaGetListLevel() {
    let loadingInstance = Loading.service({
        background: 'rgba(0, 0, 0, 0.7)',
        text: '加载中...'
    });
    console.log(store.state.bases.GetListResult.length)
    if(store.state.bases.GetListResult.length <= 0) {
        api.userCurdApi.AreaGetListLevel()
            .then(res => {
                loadingInstance.close();
                console.log('getAreaGetListLevel 成功')
                store.commit('bases/upGetListResult', res.GetListResult);
            });
    } else {
        loadingInstance.close();
    }
}

function GetRelationList() {
    let loadingInstance = Loading.service({
        background: 'rgba(0, 0, 0, 0.7)',
        text: '加载中...'
    });
    console.log(store.state.bases.GetListResult.length)
    if(store.state.bases.GetListResult.length <= 0) {
        api.userCurdApi.AreaGetListLevel()
            .then(res => {
                loadingInstance.close();
                console.log('getAreaGetListLevel 成功')
                store.commit('bases/upGetListResult', res.GetListResult);
            });
    } else {
        loadingInstance.close();
    }
}




export default {
    throttle,
    getGuid,
    getCode,
    GetInterfaceAddress,
    getUrl,
    getAreaGetListLevel,
    getAllUrl
}